module.exports = __webpack_public_path__ + "img/occidental-hotel.2658419e.jpg";